function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvisioneer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4320 4320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.71964,0,0,4.71964,63.6734,272.142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.263,174.634C555.216,173.174 467.009,236.038 436.393,329.194L559.798,400.607L434.37,473.639C460.467,574.79 544.019,633.256 656.904,633.256C751.582,633.256 842.012,589.761 867.3,489.418L737.219,489.418C723.136,519.956 691.7,538.931 658.118,537.162C599.45,537.162 565.867,497.915 563.44,438.438L874.38,438.438C880.854,291.565 804.99,175.443 653.263,175.443L653.263,174.634ZM563.44,359.944C571.734,307.345 603.9,271.537 653.263,271.537C699.792,273.917 736.53,313.362 735.6,359.944L563.44,359.944Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Diamond",
    transform: "matrix(20.2304,0,0,20.2304,13.5783,0.247902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,21L0.05,21L18.53,39.52L24.78,33.26C23.266,32.526 21.908,31.508 20.78,30.26C18.483,27.707 17.146,24.431 17,21Z",
    style: {
      fill: "rgb(209,49,56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.78,9.81C22.017,8.47 23.519,7.4 25.19,6.67L18.53,0L0,18.52L17,18.52C17.254,15.283 18.573,12.219 20.75,9.81L20.78,9.81Z",
    style: {
      fill: "rgb(209,49,56)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvisioneer);
export default __webpack_public_path__ + "static/media/envisioneer.b9675d31710eabd34d3666186ade993d.svg";
export { ForwardRef as ReactComponent };